// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ constants
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class HireCardNerudaStep2 extends React.Component {

    render() {
        const {
            extraImage,
            getContextTranslate,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardNeruda,
        } = this.props;

        const cardImageIds = [
            `B.${immHireCardNeruda.get('type')}.${immHireCardNeruda.get('subtype')}.${immHireCardNeruda.get('standard').substr(-3)}`
        ];

        const disclaimerPersonalInfoUrl = formatText(getContextTranslate('disclaimerPersonalInfoLinkUrlNeruda'));

        return (
            <article className="hire-card-neruda__step-two">
                <FormattedText
                    className="hire-card-neruda__step-title"
                    value={getContextTranslate('step2Title')}
                />
                <HireCardImageSelector
                    cardImageIds={cardImageIds}
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                    isNerudaCard={true}
                />
                <HireCardNameSelector
                    borderTop={true}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                {immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS) &&
                    <OKMessage type="informative">
                        <FormattedText value={getContextTranslate('disclaimerPersonalInfoMsgNeruda')} />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value={getContextTranslate('disclaimerPersonalInfoLinkTextNeruda')} />
                        </OKLink>
                    </OKMessage>
                }
            </article>
        );
    }
}

HireCardNerudaStep2.propTypes = {
    extraImage: PropTypes.string,
    getContextTranslate: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardNeruda: PropTypes.object.isRequired,
};

module.exports = HireCardNerudaStep2;
